// Textos de la caja de contingencia (modo contingencia, pasos 3c y 3d).
// Ver app/components/contingencia/caja-contingencia.tsx.
import { defineTextos } from '../textos.ts';

export const textosContingencia = defineTextos({
  titulo: 'Caja de contingencia',
  volver: 'Volver a la app',
  sinConexion: 'Sin conexión',
  conConexion: 'Hay conexión',
  pendientes1: '1 pedido solo en este equipo',
  pendientesN: '{n} pedidos solo en este equipo',
  datosDe: 'Carta y mesas de las {hora}',
  copiaVieja: 'La copia tiene más de 30 minutos: confirma los precios con el papel.',
  sinCopia: 'Este equipo no tiene copia de la carta. Trabaja en papel hasta que vuelva la conexión.',
  cargando: 'Cargando la copia local…',

  mesas: 'Mesas',
  paraLlevar: 'Para llevar',
  nuevoParaLlevar: 'Nuevo para llevar',
  enEsteEquipo: 'En este equipo',
  ninguno: 'Ninguno todavía',
  libre: 'Libre',
  ocupada: 'Con pedido',
  enContingencia: 'En contingencia',

  buscarPlato: 'Buscar plato…',
  todas: 'Todas',
  opcionesEnPapel: 'opciones en el papel',
  eligeDestino: 'Elige una mesa o "Nuevo para llevar" a la izquierda.',
  eligeAntes: 'Primero elige una mesa o un pedido para llevar.',

  yaEstaba: 'ya estaba',
  yaEstabaNota: 'Lo que ya estaba en el pedido no se puede quitar sin conexión.',
  facturadoNota: 'Este pedido ya estaba facturado: solo falta cobrarlo.',
  sinPlatos: 'Toca un plato para agregarlo.',
  consumo: 'Consumo',
  propina: 'Propina',
  total: 'Total',
  imprimirResumen: 'Imprimir resumen',
  cobrar: 'Cobrar',
  guardadoEquipo: 'Guardado en este equipo',
  cobradoPendiente: 'Cobrado, pendiente de subir',
  subido: 'Subido',
  requiereRevision: 'Requiere revisión',
  guardando: 'Guardando…',
  noSeGuardo: 'No se pudo guardar en este equipo. No sigas: anota el pedido en papel y avisa al administrador.',
  habilitaPopups: 'Permite las ventanas emergentes para imprimir el resumen.',

  cobroTitulo: 'Cobrar {destino}',
  sinPropina: 'Sin propina',
  efectivo: 'Efectivo',
  datafono: 'Datáfono',
  datafonoNota: 'Cobra en el datáfono y escribe el número de aprobación del voucher.',
  recibido: 'Recibido',
  cambio: 'Cambio',
  voucher: 'Número de aprobación',
  correoFE: 'Correo para factura electrónica (opcional)',
  correoFENota: 'Queda anotado. La factura se envía desde Facturación cuando vuelva la conexión.',
  boldDesactivado: 'Bold, QR y pagos en línea no funcionan en contingencia.',
  cancelar: 'Cancelar',
  confirmarCobro: 'Confirmar cobro',

  resumenTitulo: 'Resumen del pedido',
  resumenAviso: 'Documento de verificación. NO es factura ni comprobante de pago.',
  resumenContingencia: 'Hecho en la caja de contingencia, sin conexión.',
  resumenNota: 'Los precios de la carta ya incluyen el impuesto al consumo.',
  cant: 'Cant.',
  item: 'Item',
  imprimir: 'Imprimir',

  subiendo: 'Subiendo…',
  enviado: 'enviado',
  enSistema: 'En el sistema',
  subidoFactura: 'Subido · {factura}',
  volvioConexion: 'Volvió la conexión: lo de esta caja se está subiendo solo. Los pedidos abiertos pasan a la pantalla de siempre.',
  todoSubido: 'Todo lo de esta caja ya está en el sistema. Puedes volver a la app.',
  hayRevision1: '1 pedido no se pudo subir y requiere revisión. Avisa al administrador.',
  hayRevisionN: '{n} pedidos no se pudieron subir y requieren revisión. Avisa al administrador.',
  revisionTitulo: 'No se pudo subir {paso}. El servidor respondió:',
  revisionQueHacer: 'Lo que está antes de este paso sí quedó en el sistema; lo demás no. Avisa al administrador antes de reintentar.',
  reintentarSubida: 'Reintentar subida',
  pasoCrear: 'el pedido',
  pasoAgregar: 'un plato',
  pasoFacturar: 'la factura',
  pasoPagar: 'el pago',
  subidoNota: 'Ya está en el sistema: facturado ({factura}) y pagado.',
  enSistemaNota: 'Ya está en el sistema ({referencia}). Sigue con este pedido en la pantalla de siempre.',
  pidioFE: 'Pidió factura electrónica a {correo}: envíala desde Facturación.',
}, {
  titulo: 'Contingency register',
  volver: 'Back to the app',
  sinConexion: 'Offline',
  conConexion: 'Connection is back',
  pendientes1: '1 order only on this device',
  pendientesN: '{n} orders only on this device',
  datosDe: 'Menu and tables from {hora}',
  copiaVieja: 'The copy is more than 30 minutes old: check prices against the paper.',
  sinCopia: 'This device has no copy of the menu. Work on paper until the connection is back.',
  cargando: 'Loading the local copy…',

  mesas: 'Tables',
  paraLlevar: 'Takeaway',
  nuevoParaLlevar: 'New takeaway',
  enEsteEquipo: 'On this device',
  ninguno: 'None yet',
  libre: 'Free',
  ocupada: 'Has an order',
  enContingencia: 'In contingency',

  buscarPlato: 'Search dish…',
  todas: 'All',
  opcionesEnPapel: 'options on paper',
  eligeDestino: 'Choose a table or "New takeaway" on the left.',
  eligeAntes: 'First choose a table or a takeaway order.',

  yaEstaba: 'already there',
  yaEstabaNota: 'What was already in the order cannot be removed while offline.',
  facturadoNota: 'This order was already invoiced: it only needs to be charged.',
  sinPlatos: 'Tap a dish to add it.',
  consumo: 'Consumption',
  propina: 'Tip',
  total: 'Total',
  imprimirResumen: 'Print summary',
  cobrar: 'Charge',
  guardadoEquipo: 'Saved on this device',
  cobradoPendiente: 'Charged, waiting to upload',
  subido: 'Uploaded',
  requiereRevision: 'Needs review',
  guardando: 'Saving…',
  noSeGuardo: 'Could not save on this device. Stop: write the order on paper and tell the manager.',
  habilitaPopups: 'Allow pop-up windows to print the summary.',

  cobroTitulo: 'Charge {destino}',
  sinPropina: 'No tip',
  efectivo: 'Cash',
  datafono: 'Card terminal',
  datafonoNota: 'Charge on the card terminal and type the approval number from the voucher.',
  recibido: 'Received',
  cambio: 'Change',
  voucher: 'Approval number',
  correoFE: 'Email for the electronic invoice (optional)',
  correoFENota: 'It is noted down. The invoice is sent from Invoicing when the connection is back.',
  boldDesactivado: 'Bold, QR and online payments do not work in contingency.',
  cancelar: 'Cancel',
  confirmarCobro: 'Confirm charge',

  resumenTitulo: 'Order summary',
  resumenAviso: 'Verification document. NOT an invoice or a payment receipt.',
  resumenContingencia: 'Made in the contingency register, offline.',
  resumenNota: 'Menu prices already include the consumption tax.',
  cant: 'Qty',
  item: 'Item',
  imprimir: 'Print',

  subiendo: 'Uploading…',
  enviado: 'sent',
  enSistema: 'In the system',
  subidoFactura: 'Uploaded · {factura}',
  volvioConexion: 'The connection is back: this register is uploading on its own. Open orders move to the usual screen.',
  todoSubido: 'Everything from this register is in the system. You can go back to the app.',
  hayRevision1: '1 order could not be uploaded and needs review. Tell the manager.',
  hayRevisionN: '{n} orders could not be uploaded and need review. Tell the manager.',
  revisionTitulo: 'Could not upload {paso}. The server answered:',
  revisionQueHacer: 'What comes before this step is in the system; the rest is not. Tell the manager before retrying.',
  reintentarSubida: 'Retry upload',
  pasoCrear: 'the order',
  pasoAgregar: 'a dish',
  pasoFacturar: 'the invoice',
  pasoPagar: 'the payment',
  subidoNota: 'It is in the system: invoiced ({factura}) and paid.',
  enSistemaNota: 'It is in the system ({referencia}). Continue this order on the usual screen.',
  pidioFE: 'Asked for an electronic invoice to {correo}: send it from Invoicing.',
});
